import { Cable, CableTermType, CommodityName, Equipment, PrimaryStatus } from '@bechtel/sr-types';

export interface OverridePrimaryStatusFormikState {
  commodityType: string;
  newConstructionStatus: Cable['constructionStatus'];
  oldPrimaryStatus: Equipment['primaryStatus'];
  newPrimaryStatus: Cable['primaryStatus'];
  retainReels: boolean;
  whereClause: string;
  cableTermType: CableTermType;
}

export const overridePrimaryStatusInitialValues: OverridePrimaryStatusFormikState = {
  commodityType: CommodityName.CABLE,
  oldPrimaryStatus: PrimaryStatus.P,
  newPrimaryStatus: PrimaryStatus.R,
  newConstructionStatus: null,
  retainReels: true,
  whereClause: '',
  cableTermType: CableTermType.F,
};
